import {ButtonType, ButtonWidget} from '@tableau/widgets';
import React from 'react';

import {ToasterService, ToastType} from '~commonInfra/services/ToasterService';
import {Messages} from '~src/codegen/Localize';
import {generateKeyButton} from '~src/kmsInOnline/assets/KMSInOnlineSettingsStyles';
import {IGetSiteEncryptionKeyResult} from '~src/kmsInOnline/serverApi/GetSiteEncryptionKeyRequest';
import {RotateSiteEncryptionKeyService} from '~src/kmsInOnline/services/RotateSiteEncryptionKeyService';
import {
  keyNotFoundError,
  retrieveExtractKey
} from '~src/settings/general-settings/components/sections/kms-in-online/KMSInOnlineSection';

export const KMS_IN_ONLINE_GENERATE_KEY_BUTTON = 'kms-in-online-generate-key-button';

export function GenerateSiteEncryptionKeyButton(siteEncryptionKey: IGetSiteEncryptionKeyResult, setSiteEncryptionKey: (s: IGetSiteEncryptionKeyResult) => void): JSX.Element {
  return keyNotFoundError(siteEncryptionKey) ? <ButtonWidget
    buttonType={ButtonType.Outline}
    testId={KMS_IN_ONLINE_GENERATE_KEY_BUTTON}
    onClick={() => {
      RotateSiteEncryptionKeyService.rotateSiteEncryptionKey()
        .then(() => keyGenerationOnSuccess(siteEncryptionKey, setSiteEncryptionKey), keyGenerationOnFailure)
        .catch(() => {});
    }}
    className={generateKeyButton}
    type='button'
  > { Messages.extractEncryptionTOLKeyGenerateKeyPrompt() }
  </ButtonWidget>: null;
}

/**
 * Alert user that key generation succeeded
 */
async function keyGenerationOnSuccess(siteEncryptionKey: IGetSiteEncryptionKeyResult, setSiteEncryptionKey: (s: IGetSiteEncryptionKeyResult) => void) {
  let response = await retrieveExtractKey();
  setSiteEncryptionKey({...response});
  return ToasterService.instance.pop({ type: ToastType.Success, text: Messages.extractEncryptionTOLKeyGenerationSucceeded() });
}

/**
 * Alert user that key generation failed
 */
function keyGenerationOnFailure() {
  return ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryptionTOLKeyGenerationFailed() });
}